import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import { getWebPageSchema, getBreadcrumbSchema } from '@/lib/schema';

export default function CommunityPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd schema={getWebPageSchema('/community', 'Community Itaobuy Spreadsheet Italia', 'Unisciti alla community italiana di Itaobuy Spreadsheet. Condividi recensioni, consigli e scopri i migliori prodotti insieme ad altri appassionati di shopping internazionale.')} />
      <JsonLd schema={getBreadcrumbSchema([{ name: 'Home', url: '/' }, { name: 'Community', url: '/community' }])} />
      <Navbar />
      <section className="w-full px-6 md:px-10 pt-28 pb-12 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <nav className="flex items-center gap-2 text-xs font-body text-foreground-500 mb-6 flex-wrap">
            <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">Home</Link>
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-xs"></i>
            </span>
            <span className="text-foreground-400 whitespace-nowrap">Community</span>
          </nav>
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-4">
            Community Itaobuy Spreadsheet
          </h1>
          <p className="font-body text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            Unisciti alla community italiana di Itaobuy Spreadsheet. Condividi recensioni, consigli e scopri i migliori prodotti insieme ad altri appassionati di shopping internazionale.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-label text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-arrow-left-line text-sm"></i>
              Torna alla Home
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}